import { allUsersRoutes } from './all-users-routes';
import { clinicRoutes } from './clinic-routes';
import { healthScreeningRoutes } from './health-screening-routers';
import { mincAdminRoutes } from './minc-admin-routes';
import { teleconsultRoutes } from './teleconsult-routes';
import { telecounselRoutes } from './telecounsel-routes';
import { telefitRoutes } from './telefit-routes';
import { urlLabel } from '@/enum/PermissionEnum';
// Imported eagerly, not via lazy(): there is no <Suspense> boundary around the
// route tree, so a lazy route throws "A React component suspended while
// rendering, but no fallback UI was specified".
import DownloadPlatoFiles from '@/module/download-plato-files';
import TeleconsultNow from '@/module/teleconsult-now';
import React, { lazy } from 'react';

const ProfilePage = lazy(() => import('@/module/profile/pages/ProfilePage'));
const UserPermission = lazy(() => import('@/module/user-permission/component'));

const Home = () => <div></div>;
const ScreenQueue = () => <div></div>;
const ResultInbox = () => <div></div>;

const privaterouters = [
  ...allUsersRoutes,
  ...teleconsultRoutes,
  ...clinicRoutes,
  ...healthScreeningRoutes,
  ...telefitRoutes,
  ...mincAdminRoutes,
  ...telecounselRoutes,
  {
    path: `/${urlLabel.home}`,
    component: Home,
    exact: true,
  },
  {
    path: `/${urlLabel.screenQueue}`,
    component: ScreenQueue,
    exact: true,
  },
  {
    path: `/${urlLabel.resultInbox}`,
    component: ResultInbox,
    exact: true,
  },
  {
    path: `/${urlLabel.profileManagement}`,
    component: ProfilePage,
    exact: false,
  },
  {
    path: `/${urlLabel.userPermission}`,
    component: UserPermission,
    exact: true,
  },
  {
    path: `/${urlLabel.teleconsultNow}`,
    component: TeleconsultNow,
    exact: true,
  },
  {
    // Landing page for the Plato file-link browser extension. Not exact: the
    // S3 object key is carried as the rest of the path.
    path: `/${urlLabel.downloadPlatoFiles}`,
    component: DownloadPlatoFiles,
    exact: false,
    noLayout: true,
  },
];

export default privaterouters;
